import type { ComponentType } from "react";

import type { IconProps } from "@similarweb/icons";
import { DesktopAndMobile, DesktopComputer, MobileDevice } from "@similarweb/icons";

import type { LocationDevice } from "./types";

export const GSC_KEYWORDS_SOURCE_ID = "gsc-keywords";

export const ALL_CAMPAIGNS_QUERY_PREFIX = "ALL_CAMPAIGNS" as const;

export const COLLECTING_CAMPAIGN_POLL_INTERVAL_MS = 5 * 60 * 1000;

export enum RankTrackerQueryType {
    Campaigns = "Campaigns",
    DemoCampaigns = "DemoCampaigns",
    CurrentCampaign = "CurrentCampaign",
    KeywordsTable = "KeywordsTable",
    KeywordsQuickFilters = "KeywordsQuickFilters",
    CompetitorsTable = "CompetitorsTable",
    CompetitorsEnrichedTable = "CompetitorsEnrichedTable",
    CompetitorsReportMap = "CompetitorsReportMap",
    CompetitorsSerpFilter = "CompetitorsSerpFilter",
    CompetitorsTableFilter = "CompetitorsTableFilter",
    TrendSerpOnSite = "TrendSerpOnSite",
    TrendQuickFilters = "TrendQuickFilters",
    TrendReportTable = "TrendReportTable",
    TagsReportTable = "TagsReportTable",
    TagsReportGraph = "TagsReportGraph",
    OverviewPositionDistribution = "OverviewPositionDistribution",
    OverviewPerformanceOvertime = "OverviewPerformanceOvertime",
    AITaggingStatus = "AITaggingStatus",
    AITaggingCategories = "AITaggingCategories",
    Annotations = "Annotations",
    CampaignsConsumption = "CampaignsConsumption",
    KeywordSuggestions = "KeywordSuggestions",
    CompetitorSuggestions = "CompetitorSuggestions",
    RecentAnalysis = "RecentAnalysis",
    KeywordsSerpFeatures = "KeywordsSerpFeatures",
    PagesSerpFeatures = "PagesSerpFeatures",
    PagesReportTable = "PagesReportTable",
    PagesReportExpandedTable = "PagesReportExpandedTable",
    SerpFeatureTable = "SerpFeatureTable",
    SerpCompositionCharts = "SerpCompositionCharts",
    SerpPresenceGraphs = "SerpPresenceGraphs",
    GscProperties = "GscProperties",
    GscCountries = "GscCountries",
    GscKeywords = "GscKeywords",
    SerpSnapshot = "SerpSnapshot",
}

export const deviceIconMap: Record<LocationDevice, ComponentType<IconProps>> = {
    DESKTOP: DesktopComputer,
    MOBILE: MobileDevice,
    BOTH: DesktopAndMobile,
};
